import { whatsappLink } from "@/mocks/llkContent";

export default function WhatsAppButton() {
  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 flex items-center gap-2 px-4 sm:px-5 py-3 sm:py-3.5 bg-[#25D366] text-white font-semibold rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
    >
      <i className="ri-whatsapp-line text-lg sm:text-xl" />
      <span className="hidden sm:inline text-sm">Falar no WhatsApp</span>
    </a>
  );
}